/**
 * The element whose data-<attr> is exactly `value`, found WITHOUT building a selector from the value (21 October,
 * 16:50). A folder's key is JSON, so on dev `[data-doc-key="folder:["vitaldocuments"]"]` was not a valid selector:
 * querySelector threw inside an effect on every Back from a top folder, and React unmounted the page. The selector
 * here is only the attribute's name, fixed in code; the value is compared as a string, whatever it holds. Tested in
 * web/test/data-lookup.test.ts.
 */
export type DataAttr = 'doc-key' | 'doc';

export function findByData<T extends Element = HTMLElement>(
  root: Pick<ParentNode, 'querySelectorAll'>, attr: DataAttr, value: string,
): T | null {
  for (const el of root.querySelectorAll<T>(`[data-${attr}]`)) {
    if (el.getAttribute(`data-${attr}`) === value) return el;
  }
  return null;
}
